import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    backgroundColor: Colors.lightGray,
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: '100px',
    borderRadius: '5px',
    width: '100%',
    border: `1px solid ${Colors.lightGray}`,
  },

  loadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
    backgroundColor: Colors.lightGray,
    width: '100%',
    height: '100%',
    minHeight: '6rem',
  },

  attachmentsTitle: {
    fontSize: '1.5rem',
  },

  attachmentList: {
    listStyle: 'circle',
    paddingLeft: '1rem',

    '& > li': {
      padding: '0.2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: 12,
    },

    '& > li:hover': {
      backgroundColor: '#CECECE',
    },
  },

  listItem: {
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '& a': {
      fontWeight: 600,
      color: Colors.primaryColor,
      '&:visited': {
        color: Colors.primaryColor,
      },
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

  deleteButton: {
    transition: 'all 0.2s ease-in-out',
    '& svg:nth-child(2)': {
      display: 'none',
    },
    '& svg:first-child': {
      display: 'inline-block',
    },
    '&:hover svg:nth-child(2)': {
      display: 'inline-block',
    },
    '&:hover svg:first-child': {
      display: 'none',
    },
  },

  floatButton: {
    position: 'absolute',
    right: '1.25rem',
    bottom: '1.25rem',
  },

  fab: {
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#585656',
      transform: 'rotate(10deg)',
    },
  },

  fabContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '1rem',
    padding: '1rem',
    width: '100%',
  },
}))

export default styles
